module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Armchair-8fa3342c5cb4ddf4e899af35eea5e3fab29c4729a3f9271185a6c27861eea2e6.svg";